import axios from "axios";

export default axios.create({
  baseURL: "https://servercareseebd.careseebd.com/api/v1",
});

export const server_url = `https://servercareseebd.careseebd.com/api/v1`;
